import axios, {
  AxiosError,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios";
import { Token } from "../utils/localStorage.util";
import { ServicosApiResponse } from "../@types/servicos";
import config from "../config.js";
import { PermissoesApiResponse, PermissoesUsuarioApiResponse, PermissoesUsuarioEdicaoRequest } from "../@types/usuarios";
import { GenericActionResponse } from "../@types/index";

const apiAutenticacao = axios.create({
  baseURL: config.REACT_APP_HOST_API_AUTENTICACAO,
});

apiAutenticacao.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    const token = Token.getToken();
    if (token) {
      config.headers.Authorization = token;
    }

    if (!config.headers["Content-Type"]) {
        config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error: AxiosError) => {
    Promise.reject(error);
  }
);

apiAutenticacao.interceptors.response.use(
  (response: AxiosResponse) => {
    return response.data;
  },

  async function (error: AxiosError) {
    if (error?.code === "ERR_NETWORK") {
      return;
    }

    return Promise.reject(error);
  }
);

// Estava em servico.services
export function buscarComboPorCodigo(
  codigoCombo: string
): Promise<ServicosApiResponse> {
  return apiAutenticacao.get(`/configuracoes/combos/${codigoCombo}`);
}


export function buscarGruposUsuarios() {
  return apiAutenticacao.get(`/grupos-usuarios/`);
}

export function buscarGruposUsuariosPorTexto(textoBusca: string) {
  return apiAutenticacao.get(`/grupos-usuarios/buscar-por-texto?textoBusca=${encodeURIComponent(textoBusca)}`);
}

export function buscarUsuariosPorGrupos(idGrupo: number){
  return apiAutenticacao.get(`/grupos-usuarios/${idGrupo}`);
}

export function inserirGrupoUsuario(body: any) {
  return apiAutenticacao.post(`/grupos-usuarios/`, body);
}

export function editarGrupoUsuario(idGrupo: number, body: any) {
  return apiAutenticacao.put(`/grupos-usuarios/${idGrupo}`, body);
}

export function excluirGrupoUsuario(idGrupo: number) {
  return apiAutenticacao.delete(`/grupos-usuarios/${idGrupo}`);
  }
  
  
export function getPermissoesUsuarios(id_usuario: number): Promise<PermissoesUsuarioApiResponse> {
  return apiAutenticacao.get(`/grupos-usuarios/buscar-permissoes/${id_usuario}`);
}

export function getPermissoes(): Promise<PermissoesApiResponse> {
  return apiAutenticacao.get(`/grupos-usuarios/buscar-permissoes`);
}

export function buscarMinhasPermissoes() {
  return apiAutenticacao.get(`/usuarios/minhas-permissoes`);
}
  
  export function atualizarPermissoesUsuario(id_usuario: number, permissoes: PermissoesUsuarioEdicaoRequest): Promise<GenericActionResponse> {
    return apiAutenticacao.post(`/grupos-usuarios/atualizar-permissoes/${id_usuario}/`, permissoes);
  }

export default apiAutenticacao;
